<template>
  <div id="wrapper">
    <div class="grid-x">
      <div class="cell medium-8 large-6 medium-offset-2 large-offset-3">
        <br /><br />
        <div class="callout warning large align-c">
          <img class="img-profile" src="@/assets/img/static/Blonix.jpg" />
          <br /><br />
          <h2 class="ft-Rajdhani">Blonix Lab</h2>
          <br />
          <a href="mailto:rwolf2048@gmail.com?subject=Hello There.">
            <img
              src="https://img.shields.io/badge/Gmail-EA4335?style=for-the-badge&logo=Gmail&logoColor=white"
            />
          </a>
          &nbsp;
          <a href="https://github.com/jy-ha">
            <img
              src="https://img.shields.io/badge/Github-181717?style=for-the-badge&logo=Github&logoColor=white"
            />
          </a>
          <br /><br />
          <img
            src="https://img.shields.io/badge/Blonix%237734-5865F2?style=flat-square&logo=discord&logoColor=white"
          />
        </div>
      </div>
    </div>
    <div class="align-c color-white">
      <br /><br />
      <h5 class="ft-Rajdhani">Life is sequence of creating my own universe.</h5>
      <div id="ad-container"></div>
      <br /><br /><br /><br />
      <h2 class="ft-Rajdhani">Services</h2>
      <br />
    </div>

    <div class="grid-container">
      <div class="grid-x grid-margin-x equal-height-cards">
        <div class="cell large-3 medium-6 small-12">
          <a href="https://hiremind.work" target="_blank">
            <div style="height: 320px; width: 280px" class="card bg-yellow">
              <img
                style="height: 180px; width: 100%; object-fit: contain"
                src="https://hiremind.work/logo.png"
              />
              <div class="card-section ft-normal">
                <h4 class="ft-Rajdhani align-c">HireMind</h4>
                <p>HR 온톨로지 AI 솔루션</p>
              </div>
            </div>
          </a>
        </div>
        <div class="cell large-3 medium-4 small-12">
          <router-link to="/nixterminal">
            <div style="height: 320px; width: 280px" class="card bg-yellow">
              <img
                style="height: 180px; width: 100%; object-fit: contain"
                src="https://assets.blonix.dev/etc/terminal.png"
              />
              <div class="card-section ft-normal">
                <h4 class="ft-Rajdhani align-c">Nix Terminal</h4>
                <p>국내상장기업 분석 터미널</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="cell large-3 medium-6 small-12">
          <a href="https://alchemist.blonix.dev" target="_blank">
            <div style="height: 320px; width: 280px" class="card bg-yellow">
              <img
                style="height: 180px; width: 100%; object-fit: contain"
                src="https://alchemist.blonix.dev/assets/favicon-B_h98j2a.svg"
              />
              <div class="card-section ft-normal">
                <h4 class="ft-bold align-c">Alchemist</h4>
                <p>재료를 조합하는 연금술 게임</p>
              </div>
            </div>
          </a>
        </div>
        <div class="cell large-3 medium-6 small-12">
          <router-link to="/morning">
            <div style="height: 320px; width: 280px" class="card bg-yellow">
              <img
                style="height: 180px; width: 100%; object-fit: contain"
                src="https://assets.blonix.dev/etc/KoreanBarrackSquare.jpg"
              />
              <div class="card-section ft-normal">
                <h4 class="ft-bold align-c">아침 체조</h4>
                <p>Korean Barrack Square 아침 점호 출석체크</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="cell large-3 medium-6 small-12">
          <router-link to="/vrctorage">
            <div style="height: 320px; width: 280px" class="card bg-yellow">
              <img
                style="height: 180px; width: 100%; object-fit: contain"
                src="https://assets.blonix.dev/etc/vrctorage.jpg"
              />
              <div class="card-section ft-normal">
                <h4 class="ft-Rajdhani align-c">VRCtorage</h4>
                <p>VRC Variable Storage</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="cell large-3 medium-6 small-12">
          <div style="height: 320px; width: 280px" class="card bg-yellow">
            <img
              style="height: 180px; width: 100%; object-fit: contain"
              src="https://assets.blonix.dev/etc/no_image_dark.jpg"
            />
            <div class="card-section ft-normal">
              <h4 class="ft-Rajdhani align-c">준비중...</h4>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css"></style>

<script>
export default {
  name: "IntroMain",
  components: {},
};
</script>
